var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOrangeLevel = function SvgOrangeLevel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 109.615,
    viewBox: "0 0 133 109.615",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ILUSTRA",
    transform: "translate(-101.853 -185.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    d: "M25.059,24.734c10.7,0,19.378,2.169,19.378,4.844s-8.677,4.844-19.378,4.844S5.681,32.252,5.681,29.578,14.359,24.734,25.059,24.734Z",
    transform: "translate(144.066 260.586)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela",
    transform: "translate(137.458 218.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M61.915,30.958A30.958,30.958,0,1,1,30.958,0,30.962,30.962,0,0,1,61.915,30.958Z",
    transform: "translate(-0.105 0.46)",
    fill: "#f5b827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal",
    d: "M33.187,60.095l-9.866,6.5L27.55,55.324l-8.456-5.638h9.866l4.228-11.275,4.228,11.275h9.866l-8.456,5.638L43.053,66.6l-9.866-6.5Z",
    transform: "translate(-2.198 -21.952)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "raios",
    transform: "translate(103.353 186.893)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_38",
    "data-name": "Linha 38",
    y1: 22.451,
    transform: "translate(65.261 0)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_39",
    "data-name": "Linha 39",
    y1: 19.443,
    x2: 11.225,
    transform: "translate(86.501 8.839)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_40",
    "data-name": "Linha 40",
    y1: 11.225,
    x2: 19.441,
    transform: "translate(101.98 32.726)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_41",
    "data-name": "Linha 41",
    x2: 22.45,
    transform: "translate(107.55 65.261)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_42",
    "data-name": "Linha 42",
    x2: 19.443,
    y2: 11.224,
    transform: "translate(101.718 86.502)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_46",
    "data-name": "Linha 46",
    x1: 19.442,
    y2: 11.225,
    transform: "translate(8.578 86.049)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_47",
    "data-name": "Linha 47",
    x1: 22.45,
    transform: "translate(0 64.739)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_48",
    "data-name": "Linha 48",
    x1: 19.442,
    y1: 11.225,
    transform: "translate(8.839 32.274)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_49",
    "data-name": "Linha 49",
    x1: 11.225,
    y1: 19.441,
    transform: "translate(32.726 8.578)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrangeLevel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orange_level.ce033d18.svg";
export { ForwardRef as ReactComponent };